export default __webpack_public_path__ + "static/media/img3.da332d85.jpg";